import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CallTableViewModel, { orderByOptions } from '../../../ViewModels/CallTableViewModel';

interface IOrderByDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function OrderByDialog({ open, setOpen, callTableViewModel, setCallTableViewModel }: IOrderByDialogProps) {
    const [orderBy, setOrderBy] = useState<string>('');

    useEffect(() => {
        if (open) {
            //handles if order by is null bay assigning a default value
            const current = callTableViewModel.filters.orderBy;
            setOrderBy(orderByOptions.some(o => o.value === current) ? current : orderByOptions[0].value);
        }
    }, [open])

    const handleSaleFilterChange = (e: any) => {
        setOrderBy(e.target.value)
    }

    const confirm = () => {
        const newCallTableViewModel = { ...callTableViewModel };

        newCallTableViewModel.filters.orderBy = orderBy;

        setCallTableViewModel({
            ...newCallTableViewModel
        })

        setOpen(false);
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='sm'>
            <DialogTitle>Order By</DialogTitle>
            <DialogContent>
                <Grid container height='100%'>
                    <Grid key='orderBy' size={12}>
                        <InputLabel>Order By</InputLabel>
                        <Select
                            name='orderBy'
                            onChange={handleSaleFilterChange}
                            value={orderBy}
                            fullWidth
                        >
                            {orderByOptions.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
                        </Select>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}